<!--
 * @Date: 2022-07-07 19:35:08
 * @LastEditTime: 2022-11-24 14:57:51
 * @FilePath: /vue-medweb/packages/vue-m-vaccine-prefecture/src/views/VaccineList/index.vue
 * @Description: 疫苗列表页
-->
<template>
  <div class="vaccine-list-wrap">
    <Loading v-if="loading" />
    <div v-else>
      <!-- 全部疫苗展示的样式 -->
      <div
        v-if="category === 'all' && activityInfo.desc"
        class="all-vaccine-strategy-wrap"
      >
        <StrategyCard :strategy="activityInfo" />
      </div>
      <!-- 其他疫苗展示的样式 -->
      <div v-else>
        <img v-if="introImg" class="into-img" :src="introImg" />
        <div v-if="activityInfo.desc" class="strategy-wrap">
          <StrategyCard :strategy="activityInfo" />
        </div>
        <div v-if="introImg || activityInfo.desc" class="margin" />
      </div>
      <!-- 筛选器部分 -->
      <van-sticky :offset-top="0">
        <div class="filter-wrap">
          <Select
            v-model="userLocation"
            :columns="hasVaccineLocationList"
            :add-margin="true"
            @select="selectFilter"
          />
          <Select v-model="hasStock" :columns="status" @select="selectFilter" />
        </div>
        <Radio
          v-if="isShowRadioLength"
          v-model="typeName"
          :choose-list="typeList"
          @select="doPoint"
        />
      </van-sticky>
      <div
        v-if="tips && vaccineList.length"
        :class="['tips', { 'no-padding': !isShowRadioLength }]"
      >
        {{ tips }}
      </div>
      <!-- 疫苗列表 -->
      <List
        v-if="vaccineList.length && !listLoading"
        :vaccine-list="vaccineList"
      />
      <Empty v-if="!vaccineList.length && !listLoading" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import cyShare from '@cy/share';
import Loading from '@/components/Loading/index.vue';
import Select from '@/components/Select';
import StrategyCard from '@/components/StrategyCard';
import {
  getHasVaccineLocations,
  getListInfo,
  getVaccineList,
} from '@/services/vaccineList';
import doPoint from '@/services/doPoint';
import List from './components/List.vue';
import Empty from './components/Empty.vue';
import Radio from './components/Radio.vue';
import { status } from './config';

export default {
  name: 'VaccineList',
  components: {
    Loading,
    StrategyCard,
    List,
    Select,
    Radio,
    Empty,
  },
  data() {
    return {
      loading: false,
      listLoading: false,
      category: this.$route.query.category, // 疫苗类型
      introImg: '', // 头图
      hasVaccineLocationList: [], // 有疫苗城市列表
      activityInfo: {}, // 疫苗攻略
      typeList: [], // 疫苗的子类集合
      vaccineList: [], // 疫苗列表
      tips: '', // 提示
      hasStock: this.$route.query.hasStock || '全部', // 是否有现货
      typeName: this.$route.query.typeName || 'all', // 选中的子类名称
      userLocation: [], // 用户所在位置信息
      status, // 疫苗可选状态
    };
  },
  computed: {
    ...mapState('publicStore', {
      app: 'app',
    }),
    isShowRadioLength() {
      return this.typeList?.length >= 2;
    },
  },
  watch: {
    $route: {
      deep: true,
      handler(val) {
        console.log('val', val);
        const {
          hasStock = '全部',
          typeName = 'all',
          provice = '北京市',
          city = '北京市',
        } = val.query;
        this.hasStock = hasStock;
        this.typeName = typeName;
        this.userLocation = [provice, city];
        this.getVaccineList();
      },
    },
  },
  mounted() {
    this.userLocation = JSON.parse(
      sessionStorage.getItem('USER_LOCATION') || '[]'
    );
    console.log('this.userLocation', this.userLocation);
    // 用于分享及其他sessionStorage为空的情况
    if (this.userLocation.length < 2) {
      const { provice = '北京市', city = '北京市' } = this.$route.query;

      this.userLocation = [provice, city];
    }
    this.selectFilter({
      provice: this.userLocation[0],
      city: this.userLocation[1],
    });
    this.getHasVaccineLocations();
    this.getListInfo();
    this.getVaccineList();
    this.doPoint();
    this.setShareInfo();
  },
  methods: {
    /**
     * @description 获取有疫苗的城市
     */
    async getHasVaccineLocations() {
      const { error_code, error_msg, city_list } = await getHasVaccineLocations(
        {
          category: this.category,
        }
      );
      if (error_code === 0) {
        this.hasVaccineLocationList = city_list;
      } else {
        this.$toast(error_msg || '获取有疫苗城市列表出错');
      }
    },
    /**
     * @description 获取列表页信息(头图、疫苗攻略、子类等)
     */
    async getListInfo() {
      this.loading = true;
      const {
        error_code,
        error_msg,
        intro_img = '',
        activity_info = {},
        type_list = [],
      } = await getListInfo({
        category: this.category,
      });
      if (error_code === 0) {
        this.loading = false;
        this.introImg = intro_img;
        this.activityInfo = activity_info;
        this.typeList = type_list;
      } else {
        this.loading = false;
        this.$toast(error_msg || '获取列表页信息出错');
      }
    },
    /**
     * @description 获取疫苗列表
     */
    async getVaccineList() {
      this.listLoading = true;
      console.log('userLocation', this.userLocation);
      const {
        error_code,
        error_msg,
        tips = '',
        vaccine_list = [],
      } = await getVaccineList({
        category: this.category,
        city: this.userLocation[1],
        type_name: this.typeName,
        has_stock: this.hasStock !== '全部',
      });
      if (error_code === 0) {
        this.listLoading = false;
        this.vaccineList = vaccine_list;
        this.tips = tips;
      } else {
        this.listLoading = false;
        this.$toast(error_msg || '获取疫苗列表出错');
      }
    },
    /**
     * @description 打点
     * @param {object} obj 点击的子类的名称
     */
    doPoint(obj) {
      // 由于点击子类需要打点
      if (obj) {
        this.typeName = obj.typeName;
        this.selectFilter({ typeName: obj.typeName });
      }
      const findObj =
        this.typeList.find(item => this.typeName === item.type_key) || {};
      doPoint('PageView', {
        app: this.app,
        page_readable_name: '疫苗专区疫苗列表页',
        type: findObj.type_name || '全部',
      });
    },
    /**
     * @description 点击筛选器
     * @param {object} obj 筛选的子类的值
     */
    selectFilter(obj) {
      this.replaceUrlQuery(obj);
    },
    /**
     * @description 重新加载路由，让页面回到顶部
     * @param {object} newQueryObj 新修改的query
     */
    replaceUrlQuery(newQueryObj) {
      const currentQueryObj = JSON.parse(JSON.stringify(this.$route.query));
      const mergedQueryObj = Object.assign(currentQueryObj, newQueryObj);
      this.$router.replace({
        query: mergedQueryObj,
      });
    },
    /**
     * 设置分享信息
     */
    setShareInfo() {
      const shareInfo = {
        title: '春雨医生疫苗预约',
        desc: '正品保障 安心预约',
        userName: 'gh_681d3fd5683f',
        mini_id: 'gh_681d3fd5683f',
        path: `/pages/h5_webview/index?url=${encodeURIComponent(
          window.location.href
        )}`,
        mini_image:
          'https://staff.chunyu.mobi/@/media/images/2022/11/09/f530/dea627fe91fa_w750_h602_.png',
        wx_scene_timeline_desc: '春雨医生疫苗预约｜正品保障 安心预约',
      };
      cyShare.app(shareInfo);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@@/styles/mixin.scss';
.vaccine-list-wrap {
  width: 100%;
  min-height: 100vh;
  text-align: left;
  .into-img {
    display: block;
    width: 100%;
    height: auto;
  }
  .margin {
    width: 100%;
    height: rem(10);
    background: #f7f7f7;
  }
  .strategy-wrap {
    padding: 0 rem(15) rem(12);
    background: #fff;
  }
  .all-vaccine-strategy-wrap {
    width: 100%;
    height: auto;
    margin-bottom: rem(10);
    padding: rem(25) rem(15) rem(15);
    background: url('https://resource.chunyu.mobi/@/media/images/2022/07/20/6a79/ce07c90c5352_w1125_h333_.png')
      0 0 no-repeat;
    background-size: 100% 100%;
  }
  .vaccine-card {
    &:last-child::after {
      border-color: #fff;
    }
  }
  .list-content {
    padding: 0 rem(15);
  }
  .filter-wrap {
    display: flex;
    flex-direction: flex-start;
    align-items: center;
    padding: 0 rem(15);
    text-align: left;
    background: #fff;
  }
  .tips {
    padding: rem(15) rem(15) 0;
    color: #666;
    font-size: rem(12);
    background: #fff;
  }
  .no-padding {
    padding-top: 0;
  }
}
</style>
